import { MathUtils } from "@/lib/main";
import { DonutChartPiePropTypes } from "@/lib/types/visualizations/charts/DonutChart.types";
import { CSSProperties } from "react";

export default function DonutChartPie({
  size,
  total,
  blueValue = 0,
  yellowValue = 0,
  greenValue = 0,
  redValue = 0,
}: DonutChartPiePropTypes) {
  const bluePercent = MathUtils.safeMultiply(
    MathUtils.safeDivide(blueValue, total),
    100
  );
  const yellowPercent = MathUtils.safeMultiply(
    MathUtils.safeDivide(MathUtils.safeAdd(blueValue, yellowValue), total),
    100
  );
  const greenPercent = MathUtils.safeMultiply(
    MathUtils.safeDivide(
      MathUtils.safeAdd(greenValue, blueValue, yellowValue),
      total
    ),
    100
  );

  const redPercent = MathUtils.safeMultiply(
    MathUtils.safeDivide(
      MathUtils.safeAdd(redValue, greenValue, blueValue, yellowValue),
      total
    ),
    100
  );

  // Build gradient stops dynamically based on which values exist
  const gradientStops: string[] = ["var(--color-background-frame) 0 0.9deg"];

  const segments = [
    { value: blueValue, percent: bluePercent, color: "blue" },
    { value: yellowValue, percent: yellowPercent, color: "yellow" },
    { value: greenValue, percent: greenPercent, color: "green" },
    { value: redValue, percent: 100, color: "red" },
  ];

  segments.forEach((segment, index) => {
    if (segment.value > 0) {
      const isLast = index === segments.length - 1;
      gradientStops.push(
        `var(--color-${segment.color}-500) 0 calc(${segment.percent}% - 0.25%)`,
        `var(--color-background-frame) 0 ${
          isLast ? "100%" : `calc(${segment.percent}% + 0.25%)`
        }`
      );
    }
  });

  const variableStyles = {
    "--bluePercent": `${bluePercent}%`,
    "--yellowPercent": `${yellowPercent}%`,
    "--greenPercent": `${greenPercent}%`,
    "--redPercent": `${redPercent}%`,
  } as CSSProperties;

  const divStyle: CSSProperties = {
    ...variableStyles,

    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: size === "large" ? "15rem" : "10rem",
    height: size === "large" ? "15rem" : "10rem",
    borderRadius: "50%",

    backgroundImage: `conic-gradient(${gradientStops.join(", ")})`,
  };

  return <div style={divStyle} />;
}
